angular.module('zc.projects')

.directive 'zcCartPriceEditor', (ProjectCartPrice, Meta, BaseProjectCrudEditor) ->

  class CartPriceEditor extends BaseProjectCrudEditor
    link: (scope, element, attrs) ->
      # only this specific functionality
      scope.cartPricePageTypes = []

      Meta.getCartPricePageTypes().then (res) ->
        scope.cartPricePageTypes = res

  editor = new CartPriceEditor(
    ProjectCartPrice
    Meta
    '/templates/projects.settings/initialization/cart_price_editor.html'
  )

  return editor.createDirective()




// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/initialization/cart_price_editor.directive.coffee